export type OfficeErrorLike = {
  code: string;
  message: string;
  errorLocation?: string;
};

/**
 * `OfficeExtension.Error` carries `name: "RichApi.Error"`; matching on that
 * too keeps the mapping working where the global isn't the same realm (tests,
 * bundled copies).
 */
export function asOfficeError(err: unknown): OfficeErrorLike | null {
  if (err === null || typeof err !== "object") {
    return null;
  }
  const e = err as {
    name?: unknown;
    code?: unknown;
    message?: unknown;
    debugInfo?: { errorLocation?: unknown };
  };
  const isOffice =
    (typeof OfficeExtension !== "undefined" &&
      err instanceof OfficeExtension.Error) ||
    e.name === "RichApi.Error";
  if (!isOffice || typeof e.code !== "string") {
    return null;
  }
  const location = e.debugInfo?.errorLocation;
  return {
    code: e.code,
    message: typeof e.message === "string" ? e.message : "",
    errorLocation:
      typeof location === "string" && location ? location : undefined,
  };
}

/** ` (at Worksheet.getRange)`, or "" when Office didn't report a location. */
export function officeErrorLocation(err: OfficeErrorLike): string {
  return err.errorLocation ? ` (at ${err.errorLocation})` : "";
}
